export default {
  allCategory(state) {
    return state.categoryList;
  },

  getSingleCategory(state) {
    return state.oneCategory;
  },
};
